import { config } from '@carbonara/config'
import pino from 'pino'

const options = {
	browser: {
		asObject: true,
	},
} as pino.LoggerOptions

if (config.instance === 'dev') {
	options.transport = {
		target: 'pino-pretty',
		options: {
			colorize: true,
		},
	}
}

export const logger = pino(options)

export const customLogger = pino
